module.exports = __webpack_public_path__ + "static/assets/1db79d05c149cb91c52958960abc028f.png";